import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-ajuste-estoque-edit',
  templateUrl: './ajuste-estoque-edit.component.html',
  standalone: false
})
export class AjusteEstoqueEditComponent implements OnInit {

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/ajuste-estoque`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro Ajuste de Estoque', link: '/ajuste-estoque' }, { label: 'Edição Ajuste de Estoque' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'ajuste-estoque',
      // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("ajuste-estoque").subscribe((data) => {
        this.fields = data;
    });
  }

}
